<template>
  <a-drawer
    :title="title"
    :width="drawerWidth"
    :maskClosable="false"
    @close="handleCancel"
    :visible="visible"
    :confirmLoading="confirmLoading">

    <div :style="{width: '100%',border: '1px solid #e9e9e9',padding: '10px 16px',background: '#fff',}">
    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" :model="model" :rules="validatorRules">

        <a-form-model-item :label="language['premission.menuType']" :labelCol="labelCol" :wrapperCol="wrapperCol" >
          <a-radio-group @change="onChangeMenuType" v-model="model.menuType">
            <a-radio :value="0">{{language['premission.levelOneMenu']}}</a-radio>
            <a-radio :value="1">{{language['premission.submenu']}}</a-radio>
            <a-radio :value="2">{{language['premission.BP']}}</a-radio>
          </a-radio-group>
        </a-form-model-item>

        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="menuLabel"
          prop="name"
          hasFeedback >
          <a-input :placeholder="language['premission.mustPremission']" v-model="model.name" :readOnly="disableSubmit"/>
        </a-form-model-item>

        <a-form-model-item
          v-show="model.menuType==0"
          :label="language['premission.menuCategory']"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :validate-status="validateStatus"
          :hasFeedback="true"
          :required="true">
          <a-radio-group @change="" v-model="model.menuCategory">
            <a-radio value="web">web</a-radio>
            <a-radio value="app">app</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item
          v-show="model.menuType==0"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :validate-status="applicationValidateStatus"
          :hasFeedback="true"
          :required="true"
          :label="language['premission.applicationName']">
          <span slot="help">{{ applicationValidateStatus=='error'?language['premission.mustApplication']:'&nbsp;&nbsp;' }}</span><!--language['premission.mustApplication']-->
          <!--<a-input placeholder="请选择所属应用" v-model="model.applicationId" :readOnly="disableSubmit"/>-->
          <a-select
            style="width: 100%"
            allowClear
            :disabled="$store.getters.application.applicationType=='platform'?!!model.id:true"
            :placeholder="language['premission.mustApplication']"
            v-model="model.applicationId"
          >
            <a-select-option v-for="(item,index) in application" :key="index.toString()" :value="item.id">
              {{ item.applicationName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="description"
          :label="language['premission.languageKey']">
          <a-input :placeholder="language['premission.mustLanguageKey']" v-model="model.description" :readOnly="disableSubmit"/>
        </a-form-model-item>

        <a-form-model-item
          v-show="model.menuType!=0"
          :label="language['premission.previousMenu']"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :validate-status="validateStatus"
          :hasFeedback="true"
          :required="true">
          <span slot="help">{{ validateStatus=='error'?language['premission.mustPreviousMenu']:'&nbsp;&nbsp;' }}</span>
          <a-tree-select
            style="width:100%"
            :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
            :treeData="treeData"
            v-model="model.parentId"
            :placeholder="language['premission.mustPreviousMenu']"
            :disabled="disableSubmit"
            @change="handleParentIdChange">
          </a-tree-select>
        </a-form-model-item>

        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="url"
          :label="language['premission.url']">
          <a-input :placeholder="language['premission.mustURL']" v-model="model.url" :readOnly="disableSubmit"/>
        </a-form-model-item>

        <a-form-model-item
          v-show="show"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="component"
          :label="language['premission.component']">
          <a-input :placeholder="language['premission.mustComponent']" v-model="model.component" :readOnly="disableSubmit"/>
        </a-form-model-item>

        <a-form-model-item
          v-show="model.menuType==0"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['premission.redirectAddress']">
          <a-input :placeholder="language['premission.mustRedirectAddress']" v-model="model.redirect" :readOnly="disableSubmit"/>
        </a-form-model-item>

        <a-form-model-item
          v-show="!show"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="perms"
          :label="language['premission.perms']">
          <a-input :placeholder="language['premission.mustPerms']" v-model="model.perms" :readOnly="disableSubmit"/>
        </a-form-model-item>

        <a-form-model-item
          v-show="!show"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['premission.permsType']">
          <j-dict-select-tag  v-model="model.permsType" :placeholder="language['premission.mustPermsType']" :type="'radio'"  dictCode="global_perms_type"/>


        </a-form-model-item>
        <a-form-model-item
          v-show="!show"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['premission.status']">
          <j-dict-select-tag v-model="model.status" :placeholder="language['premission.musetStatus']" :type="'radio'" dictCode="valid_status"/>

        </a-form-model-item>

        <a-form-model-item
          v-show="show"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['premission.icon']">
          <a-input :placeholder="language['premission.mustIcon']" v-model="model.icon" :readOnly="disableSubmit">
            <a-icon slot="addonAfter" type="setting" @click="selectIcons" />
          </a-input>
        </a-form-model-item>

        <a-form-model-item
          v-show="show"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="sortNo"
          :label="language['common.sort']">
          <a-input-number :placeholder="language['common.mustSort']" v-model="model.sortNo" style="width: 200px" :readOnly="disableSubmit"/>
        </a-form-model-item>

        <a-form-model-item
          v-show="show"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['premission.isRoutePremission']">
          <a-switch :checkedChildren="language['common.yes']" :unCheckedChildren="language['common.no']" v-model="model.route"/>
        </a-form-model-item>

        <a-form-model-item
          v-show="show"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['premission.hidden']">
          <a-switch :checkedChildren="language['common.yes']" :unCheckedChildren="language['common.no']" v-model="model.hidden"/>
        </a-form-model-item>

        <a-form-model-item
          v-show="show"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['premission.keepAlive']">
            <a-switch :checkedChildren="language['common.yes']" :unCheckedChildren="language['common.no']" v-model="model.keepAlive"/>
        </a-form-model-item>


        <a-form-model-item
          v-show="show"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['premission.alwaysShow']">
          <a-switch :checkedChildren="language['common.yes']" :unCheckedChildren="language['common.no']" v-model="model.alwaysShow"/>
        </a-form-model-item>

        <a-form-model-item
          v-show="show"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['premission.internalOrExternal']">
          <a-switch :checkedChildren="language['premission.internal']" :unCheckedChildren="language['premission.external']" v-model="model.internalOrExternal"/>
        </a-form-model-item>

        <a-form-model-item :label="language['system.permission.extInfo']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="extInfo">
          <a-textarea v-model="model.extInfo" rows="2" :placeholder="language['common.pleaseInput']+language['system.permission.extInfo']" :readOnly="disableSubmit"/>
        </a-form-model-item>

      </a-form-model>

      <!-- 选择图标 -->
      <icons @choose="handleIconChoose" @close="handleIconCancel" :iconChooseVisible="iconChooseVisible"></icons>
    </a-spin>
      <a-row :style="{textAlign:'right'}">
        <a-button :style="{marginRight: '8px'}" @click="handleCancel">
          {{language['common.closeButton']}}
        </a-button>
        <a-button :disabled="disableSubmit" @click="handleOk" type="primary">{{language['common.determineButton']}}</a-button>
      </a-row>
    </div>
  </a-drawer>
</template>

<script>
  import { httpAction,getAction } from '@/api/manage'
  import {addPermission,editPermission,queryTreeList, duplicateCheck} from '@/api/api'
  import Icons from './icon/Icons'

  export default {
    name: "PermissionModal",
    components: {Icons},
    data () {
      return {
        application:[{
          id:'',
          applicationName:''
        }],
        drawerWidth:700,
        treeData:[],
        title:this.$store.getters.language['common.action'],
        visible: false,
        disableSubmit:false,
        model: {},
        show:true,//根据菜单类型，动态显示隐藏表单元素
        menuLabel:this.$store.getters.language['premission.name'],
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        iconChooseVisible: false,
        validateStatus:"",
        applicationValidateStatus:"",
        applicationValue:"",
      }
    },
    computed:{
      language() {
        return this.$store.getters.language
      },
      validatorRules:function() {
        return {
          name:[{ required: true, message: this.language['premission.mustPremission'] }],

          description:[{ required: true, message: this.language['premission.mustLanguageKey'] }],
          component:[{ required: this.show, message: this.language['premission.mustComponent'] }],
          url: [{ required: this.show, message: this.language['premission.mustURL'] }],
          permsType: [{ required: true, message: this.language['premission.mustPermsType'] }],
          perms:[{ required: false, message: this.language['premission.mustPerms'] },{validator: this.validatePerms }],
          extInfo:[{validator: this.validateExtInfo }],
        }
      }
    },
    created () {
    },
    methods: {
      loadTree(){
        var that = this;
        let url = ""
        if(this.$store.getters.application.applicationType=='platform'){
          url = "/sys/permission/queryTreeList"
        }else{
          url = "/sys/permission/queryTreeList?applicationId="+this.$store.getters.application.id
        }
        getAction(url).then((res)=>{
        // queryTreeList().then((res)=>{
          if(res.success){
            console.log(res)
            that.treeData = [];
            let treeList = res.result.treeList
            for(let a=0;a<treeList.length;a++){
              let temp = treeList[a];
              temp.isLeaf = temp.leaf;
              temp.title = temp.title+"("+temp.applicationName+")";
              this.editTreeData(temp);
              that.treeData.push(temp);
            }
          }
        });
      },
      editTreeData(data){
        if(data.children){
          for(let a=0;a<data.children.length;a++){
            let temp = data.children[a];
            temp.title = temp.title+"("+temp.applicationName+")";
            this.editTreeData(temp);
          }
        }
      },
      add (applicationId) {
        //初始化默认值
        this.edit({status:'1', permsType:'1', sortNo:1.0, route:true, menuType:0,applicationId:applicationId, extInfo:"",menuCategory:"web"});
      },
      edit (record) {
        this.getSysBmApplication();
        this.resetScreenSize(); // 调用此方法,根据屏幕宽度自适应调整抽屉的宽度
        this.model = Object.assign({}, record);

        //根据菜单类型，动态展示页面字段
        console.log('record: ',record)
        this.show = record.menuType==2?false:true;
        this.menuLabel = record.menuType==2?this.language['premission.BP']:this.language['premission.name'];
        this.applicationValue = record.applicationId;
        this.visible = true;
        this.loadTree();
        this.applicationValidateStatus = '';
        this.validateStatus = '';
      },
      getSysBmApplication(){
        httpAction("/sys/permission/getSysBmApplication", "", "get").then((res) => {
          if (res.success) {
            this.application = res.result;
          }
        })
      },
      close () {
        this.$emit('close');
        this.disableSubmit = false;
        this.visible = false;
        this.$refs.form.resetFields();
      },
      handleOk () {
        const that = this;
        let submitStatus = true;
        //上级菜单未选择
        if ((this.model.menuType == 1 || this.model.menuType == 2) && !this.model.parentId) {
          that.validateStatus = 'error';
          // that.$message.error("请检查你填的类型以及信息是否正确！");
          submitStatus = false;
        } else {
          that.validateStatus = 'success';
          submitStatus = true;
        }
        //所属应用未选择
        if (this.model.menuType == 0 && !this.model.applicationId) {
          that.applicationValidateStatus = 'error';
          // that.$message.error("请检查你填的类型以及信息是否正确！");
          submitStatus = false;
        } else {
          that.applicationValidateStatus = 'success';
          submitStatus = true;
        }
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            if(!submitStatus)return;
            that.confirmLoading = true;
            let obj;
            if (!this.model.id) {
              obj = addPermission(this.model);
            } else {
              obj = editPermission(this.model);
            }
            obj.then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            });
          }else{
            return false;
          }
        })
      },
      handleCancel () {
        this.close()
      },
      validateNumber(rule, value, callback){
        if(!value || new RegExp(/^[0-9]*[1-9][0-9]*$/).test(value)){
          callback();
        }else{
          callback("请输入正整数!");
        }
      },
      validatePerms(rule, value, callback){
        if(value && value.length>0){
          getAction("/sys/permission/checkBtuPerms",{parentId:this.model.parentId,id:this.model.id,perms:value}).then((res)=>{
            if (res.success) {
              callback()
            } else {
              callback(this.language['premission.isPerms'])
            }
          })
        }else{
          callback()
        }
      },

      validateExtInfo(rule, value, callback){
        let trimValue = value?value.trim():"";
        if(!trimValue){
          callback();
        } else {
          try {
            JSON.parse(trimValue); callback();
          } catch {
            callback(this.language['system.permission.jsonInvalid'])
          }
        }
      },

      /*validatePerms(rule, value, callback){
        if(value && value.length>0){
          //校验授权标识是否存在
          var params = {
            tableName: 'sys_permission',
            fieldName: 'perms',
            fieldVal: value,
            dataId: this.model.id
          };
          duplicateCheck(params).then((res) => {
            if (res.success) {
              callback()
            } else {
              callback(this.language['premission.isPerms'])
            }
          })
        }else{
          callback()
        }
      },*/
      onChangeMenuType(e) {
        if(this.model.menuType == 2){
          this.show = false;
          this.menuLabel = this.language['premission.BP'];
        }else{
          this.show = true;
          this.menuLabel = this.language['premission.name'];
          if(this.model.menuType == 1){
            this.model.applicationId = this.applicationValue;
          }else if(this.model.menuType == 0){
            if(this.$store.getters.application.applicationType!='platform'){
              this.model.applicationId = this.$store.getters.application.id
            }else{
              this.model.applicationId = '';
            }
          }
        }
        this.$nextTick(() => {
          this.$refs.form.validateField(['url','component']);
        });
      },
      selectIcons(){
        this.iconChooseVisible = true
      },
      handleIconCancel () {
        this.iconChooseVisible = false
      },
      handleIconChoose (value) {
        console.log(value)
        this.model.icon = value
        this.iconChooseVisible = false
      },
      // 根据屏幕变化,设置抽屉尺寸
      resetScreenSize(){
        let screenWidth = document.body.clientWidth;
        if(screenWidth < 500){
          this.drawerWidth = screenWidth;
        }else{
          this.drawerWidth = 700;
        }
      },
      handleParentIdChange(value){
        if(!value){
          this.validateStatus="error"
        }else{
          this.validateStatus="success"
        }
        httpAction("/sys/permission/queryById?id="+value, "", "get").then((res) => {
          if (res.success) {
            this.model.applicationId = res.result.applicationId;
            this.model.extInfo = res.result.extInfo ? res.result.extInfo : "";
          }
        })
      },
    }
  }
</script>

<style scoped>

</style>